<div class="note-web-container">
  <div class="chapeau-background"></div>
  <!-- Titre notes -->
  <app-page-title [titleKey]="'note.title'"></app-page-title>
  <app-loader [isLoading]="loading"></app-loader>


  <!-- Children Selection Buttons -->
  <div class="childselect">
    <app-children-selector 
      [(selectedStudentId)]="selectedStudentId" 
      (studentSelected)="onStudentSelected($event)">
    </app-children-selector>
  </div>

  <!-- Notes Table -->
  <div class="table-container">
    <div class="table-header">
      <h3>{{ 'note.notesFor' | translate }} {{selectedChild}}</h3>
      <div class="search-container">
        <input 
          type="text" 
          pInputText 
          placeholder="{{ 'note.searchPlaceholder' | translate }}" 
          (input)="dt.filterGlobal($any($event.target).value, 'contains')"
          class="search-input"
        />
      </div>
    </div>

    <p-table 
      [value]="filteredNotes" 
      [globalFilterFields]="['creationDate','examName','description','noteMax','noteMin']"
      #dt
      styleClass="p-datatable-striped"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'note.tableHeaders.date' | translate }}</th>
          <th>{{ 'note.tableHeaders.subject' | translate }}</th>
          <th>{{ 'note.tableHeaders.note' | translate }}</th>
          <th>{{ 'note.tableHeaders.max' | translate }}</th>
          <th>{{ 'note.tableHeaders.min' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-note>
        <tr>
          <td>{{ note.creationDate | date:'dd-MM-yyyy' }}</td>
          <td>{{ note.examName }}</td>
          <td>{{ note.description }}</td>
          <td>{{ note.noteMax }}</td>
          <td>{{ note.noteMin }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
